import { Pipe, PipeTransform } from '@angular/core';
import { Prescription } from '../models';
import { canDisplayPrescription } from '../utils/prescription.util';

@Pipe({
  name: 'canDisplayPrescription',
  standalone: true
})
export class CanDisplayPrescriptionPipe implements PipeTransform {

  transform(prescription: Prescription): boolean {
    return canDisplayPrescription(prescription);
  }

}
